import React from 'react';
import styled from 'styled-components';

import { colorScheme } from '../../theme';

interface Props {
  children: any;
  className?: string;
}

export function StaticLeftColumn(props: Props) {
  return <Column className={`h-100 ${props.className}`}>{props.children}</Column>;
}

const Column = styled.div`
  flex: 0 0 372px;
  background-color: ${colorScheme.panelBackground};

  @media screen and (max-width: 1600px) {
    flex: 0 0 372px;
  }
`;
